<template>
  <v-card v-if="loading" color="#212529"
    class="!absolute top-[10vh]  h-[75vh] !rounded-2xl right-1/3 !border-0 !w-[90%] cards_alignment" elevation="5">
    <v-skeleton-loader type="image,article" height="100%" class=" skeleton for_differ_color_card">
    </v-skeleton-loader>
  </v-card>
  <v-card v-else class="!absolute top-[10vh]  h-[75vh] !rounded-2xl right-1/3 !border-0 !w-[90%] cards_alignment"
    elevation="5" id="preview" dark>
    <div
      class="absolute top-0 left-0 h-full w-full bg-gradient-to-t from-black to-[#0000004a] for_differ_color_card bottom-0  rounded-2xl z-[1]">
    </div>
    <v-img gradient="to bottom , #0c0c0ca8 , #0000009f" height="100%" width="100%"
      lazy-src="https://picsum.photos/seed/picsum/6" :src="img" class="!rounded-2xl">
      <div
        class="drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] absolute left-[15%] top-[15vh] border-b-[1px] w-2/3 pb-3  border-gray-300 px-5">
        <h3 class="text-lg font-bold font-Nunito">
          {{ name }}
        </h3>
        <h3 class="text-sm font-Nunito">
          {{ `${age}y, ${subtitle}` }}
        </h3>
      </div>
      <div class="absolute bottom-10 p-5">
        <h3 class="text-sm font-Nunito h-14 overflow-hidden">
          {{ description }}
        </h3>
      </div>
    </v-img>

  </v-card>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    description: {
      type: String,
    },
    img: {
      type: String,
    },
    age: {
      type: String,
    },
    loading: {
      type: Boolean,
    }
  },
};
</script>

<style scoped >
.cards_alignment:nth-last-child(3) {
  right: 17% !important;
  transform: scale(0.88);
}

.cards_alignment:nth-last-child(2) {
  right: 25% !important;
  transform: scale(0.94);

}

.cards_alignment:nth-last-child(3) .for_differ_color_card {
  background: linear-gradient(to bottom, #2e3144a0, #000);
}

.cards_alignment:nth-last-child(2) .for_differ_color_card {
  background: #295225ae;
  background: linear-gradient(to bottom, #295225ae, #000);


}

.skeleton:deep(.v-skeleton-loader__image) {
  width: 100% !important;
  height: 100% !important;
  z-index: 1;
}

.skeleton:deep(.v-skeleton-loader__article) {
  position: absolute;
  z-index: 5;
  width: 100% !important;
  top: 15vh;
  left: 15%;
  border-bottom: 1px solid #333;
  width: 75%;
  border-radius: 0;
  background: transparent !important;
}
</style>
